$(document).ready(function() {
    $('.prevent-double-click').click(function() {
        window.preventDoubleClick($(this));
    });
});

window.preventDoubleClick = function(e) {
    var $this = $(e);
    $this.prop('disabled', true);

    // submit form if form exists
    if ($this.closest('form').length) {
        $this.closest('form').submit();
    }

    const text = $this.text();
    $this.html(text + '<div class="spinner-border spinner-border-sm ml-1" role="status"><span class="sr-only">Loading...</span></div>')

    setTimeout(function() {
        $this.html(text);
        $this.find('.spinner-border').remove();
        $this.prop('disabled', false);
    }, 3000);
}
